import { dew as _agentsDew } from "./agents";
import { dew as _typesDew } from "./agents/types";
import { dew as _authDew } from "./auth";
import { dew as _types2Dew } from "./auth/types";
import { dew as _cellsDew } from "./cells";
import { dew as _types3Dew } from "./cells/types";
import { dew as _commitsDew } from "./commits";
import { dew as _types4Dew } from "./commits/types";
import { dew as _commonsDew } from "./commons";
import { dew as _types5Dew } from "./commons/types";
import { dew as _documentsDew } from "./documents";
import { dew as _types6Dew } from "./documents/types";
import { dew as _environmentsDew } from "./environments";
import { dew as _types7Dew } from "./environments/types";
import { dew as _eventsDew } from "./events";
import { dew as _types8Dew } from "./events/types";
import { dew as _filesDew } from "./files";
import { dew as _types9Dew } from "./files/types";
import { dew as _guestsDew } from "./guests";
import { dew as _types10Dew } from "./guests/types";
import { dew as _jobsDew } from "./jobs";
import { dew as _types11Dew } from "./jobs/types";
import { dew as _mappingDew } from "./mapping";
import { dew as _types12Dew } from "./mapping/types";
import { dew as _propertyDew } from "./property";
import { dew as _types13Dew } from "./property/types";
import { dew as _recordsDew } from "./records";
import { dew as _types14Dew } from "./records/types";
import { dew as _secretsDew } from "./secrets";
import { dew as _types15Dew } from "./secrets/types";
import { dew as _sheetsDew } from "./sheets";
import { dew as _types16Dew } from "./sheets/types";
import { dew as _snapshotsDew } from "./snapshots";
import { dew as _types17Dew } from "./snapshots/types";
import { dew as _spacesDew } from "./spaces";
import { dew as _types18Dew } from "./spaces/types";
import { dew as _usersDew } from "./users";
import { dew as _types19Dew } from "./users/types";
import { dew as _versionsDew } from "./versions";
import { dew as _types20Dew } from "./versions/types";
import { dew as _workbooksDew } from "./workbooks";
import { dew as _types21Dew } from "./workbooks/types";
import { dew as _requestsDew } from "./files/client/requests";
import { dew as _requests2Dew } from "./records/client/requests";
import { dew as _requests3Dew } from "./snapshots/client/requests";
import { dew as _requests4Dew } from "./users/client/requests";
import { dew as _requests5Dew } from "./versions/client/requests";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = exports && exports.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
  var __exportStar = exports && exports.__exportStar || function (m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.workbooks = exports.versions = exports.users = exports.spaces = exports.snapshots = exports.sheets = exports.secrets = exports.records = exports.property = exports.mapping = exports.jobs = exports.guests = exports.files = exports.events = exports.environments = exports.documents = exports.commons = exports.commits = exports.cells = exports.auth = exports.agents = void 0;
  exports.agents = __importStar(_agentsDew());
  __exportStar(_typesDew(), exports);
  exports.auth = __importStar(_authDew());
  __exportStar(_types2Dew(), exports);
  exports.cells = __importStar(_cellsDew());
  __exportStar(_types3Dew(), exports);
  exports.commits = __importStar(_commitsDew());
  __exportStar(_types4Dew(), exports);
  exports.commons = __importStar(_commonsDew());
  __exportStar(_types5Dew(), exports);
  exports.documents = __importStar(_documentsDew());
  __exportStar(_types6Dew(), exports);
  exports.environments = __importStar(_environmentsDew());
  __exportStar(_types7Dew(), exports);
  exports.events = __importStar(_eventsDew());
  __exportStar(_types8Dew(), exports);
  exports.files = __importStar(_filesDew());
  __exportStar(_types9Dew(), exports);
  exports.guests = __importStar(_guestsDew());
  __exportStar(_types10Dew(), exports);
  exports.jobs = __importStar(_jobsDew());
  __exportStar(_types11Dew(), exports);
  exports.mapping = __importStar(_mappingDew());
  __exportStar(_types12Dew(), exports);
  exports.property = __importStar(_propertyDew());
  __exportStar(_types13Dew(), exports);
  exports.records = __importStar(_recordsDew());
  __exportStar(_types14Dew(), exports);
  exports.secrets = __importStar(_secretsDew());
  __exportStar(_types15Dew(), exports);
  exports.sheets = __importStar(_sheetsDew());
  __exportStar(_types16Dew(), exports);
  exports.snapshots = __importStar(_snapshotsDew());
  __exportStar(_types17Dew(), exports);
  exports.spaces = __importStar(_spacesDew());
  __exportStar(_types18Dew(), exports);
  exports.users = __importStar(_usersDew());
  __exportStar(_types19Dew(), exports);
  exports.versions = __importStar(_versionsDew());
  __exportStar(_types20Dew(), exports);
  exports.workbooks = __importStar(_workbooksDew());
  __exportStar(_types21Dew(), exports);
  __exportStar(_requestsDew(), exports);
  __exportStar(_requests2Dew(), exports);
  __exportStar(_requests3Dew(), exports);
  __exportStar(_requests4Dew(), exports);
  __exportStar(_requests5Dew(), exports);
  return exports;
}